const faqs = [
  {
    question: "Does Tennessee have a passport agency?",
    answer: "No — Tennessee does not have a regional passport agency within state borders. The closest regional passport agency is the Atlanta Passport Agency (230 Peachtree Street NW, Suite 1000, Atlanta, GA 30303), serving all 95 Tennessee counties. Atlanta is approximately 250 miles from Nashville, 380 miles from Memphis, 200 miles from Knoxville, and 120 miles from Chattanooga. Appointments are required. Fast Passport Center's courier service eliminates the need for any Tennessee residents to drive to Atlanta.",
  },
  {
    question: "How fast can I get a passport in Tennessee?",
    answer: "With Fast Passport Center's courier service, Tennessee travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Music industry touring schedules, medical conferences, and summer Caribbean travel are the peak demand drivers for Tennessee passport services.",
  },
  {
    question: "What is the closest passport agency for Tennessee residents?",
    answer: "The Atlanta Passport Agency at 230 Peachtree Street NW, Suite 1000, Atlanta, GA 30303 is the closest regional passport agency for Tennessee residents. This is a significant factor for Tennessee travelers — Atlanta is approximately 250 miles from Nashville (4 hours), 200 miles from Knoxville (3 hours), and 120 miles from Chattanooga (2 hours). Fast Passport Center's courier service means no Tennessee resident ever needs to make that drive.",
  },
  {
    question: "Can Chattanooga residents use the Atlanta Passport Agency?",
    answer: "Yes. Chattanooga is approximately 2 hours south of the Atlanta Passport Agency via I-75. Chattanooga travelers can use the Atlanta agency — Fast Passport Center's couriers have direct access and always choose the fastest available appointment for your timeline.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Tennessee?",
    answer: "First-time applicants, minors under 16, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). Tennessee has hundreds of acceptance facilities across all 95 counties. Renewals for adults with a passport issued within the last 15 years can usually be done by mail without an in-person visit.",
  },
  {
    question: "Can I renew my passport by mail in Tennessee?",
    answer: "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82. For faster service, use Fast Passport Center's approved expedited courier service with direct Atlanta Passport Agency access.",
  },
  {
    question: "What airport should I fly from in Tennessee for international flights?",
    answer: "Nashville International Airport (BNA) offers the most international routes in Tennessee, including British Airways nonstop to London Heathrow, direct flights to Toronto, Cancun, and numerous European and Caribbean destinations. Memphis International (MEM) has limited international passenger service. Most international travelers in East and Southeast Tennessee connect through Atlanta (ATL) or Charlotte (CLT).",
  },
  {
    question: "How quickly can Music Row professionals and musicians get passports?",
    answer: "Music industry professionals with urgent international touring needs can get emergency passports in as little as 24 hours through Fast Passport Center's direct Atlanta Passport Agency access. This is especially valuable for Nashville-based artists, producers, and label executives with last-minute international dates.",
  },
];

export default function TennesseeFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Tennessee Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Volunteer State.
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-white rounded-lg border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-[#1A365D] text-sm hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}